import styled from 'styled-components';
import { COLOR } from '@latitude/core/utils/constants';
import { hexToRgb } from '@latitude/core/helpers';
import { buttonCSS } from '@latitude/button/Button.styled';

export const StyledLink = styled.a`
  border-bottom: solid 1px rgba(${hexToRgb(COLOR.BLACK)}, 0.5);
  box-sizing: border-box;
  cursor: pointer;
  color: ${COLOR.BLACK};
  position: relative;
  text-decoration: none;
  transition: all 0.15s ease-in-out;

  ${({ tealiumDebugMode }) =>
    tealiumDebugMode &&
    `
    outline: 5px solid green !important;
    }
  `}

  &:hover {
    border-bottom: 1px solid ${COLOR.BLACK};
    text-shadow: 0 0 1px ${COLOR.BLACK};
  }

  &:active {
    top: 1px;
  }


  ${({ noStyle }) =>
    noStyle &&
    `
    border-bottom: none !important;
    color: inherit !important;
    text-shadow: none !important;
    &:active {
      top: 0 !important;
    }
  `}

  /**
   * Variant override
   */

  ${({ variant }) =>
    variant &&
    `
    border-bottom: solid 1px rgba(${hexToRgb(variant)}, 0.5);
    color: ${variant};

    &:hover {
      border-bottom: 1px solid ${variant};
      text-shadow: 0 0 1px ${variant};
    }
  `}

  ${({ button }) => button && buttonCSS[button]}};
`;
